import { BREAKPOINTS } from '../constants'
import { defaultPreset } from './default'

/** Legacy promo slider (widget--promo-slider). Always 1 slide per view. */
export const oneColPreset = {
  ...defaultPreset,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slideToClickedSlide: true,
  navigation: {
    enabled: false,
  },
  breakpoints: {
    [BREAKPOINTS.LG]: {
      navigation: {
        enabled: true,
      },
    },
  },
}
